import {
	ContentContainer,
	// ContentMenu,
	// ContentBody,
} from "@/pages/layouts/main-content";
import { PlayView } from "@/pages/subs/play/play-view";
import { PlayProvider } from "@/providers/play-provider";

export function MainPlay({ hidden }: { hidden?: boolean }) {
	return (
		<ContentContainer hidden={hidden}>
			<div className="w-full h-full flex flex-col">
				<PlayProvider>
					<PlayView />
				</PlayProvider>
			</div>
		</ContentContainer>
	);
}
